// extracted by mini-css-extract-plugin
export var actionButton = "_j3-t";
export var buttonContainer = "_j3-0";
export var buttonContainer2 = "_j3-1";
export var buttonSection = "_j3-2";
export var details = "_j3-3";
export var dropdownItem = "_j3-5";
export var dropdownItemsContainer = "_j3-4";
export var fileInput = "_j3-r";
export var headerButton = "_j3-6";
export var icon = "_j3-7";
export var input = "_j3-8";
export var macroListItem = "_j3-9";
export var mainContent = "_j3-a";
export var microText = "_j3-b";
export var modal = "_j3-w";
export var optionsButton = "_j3-c";
export var paperclip = "_j3-s";
export var pillContent = "_j3-d";
export var preview = "_j3-e";
export var preview2 = "_j3-f";
export var quillEditor = "_j3-q";
export var selectedMacro = "_j3-g";
export var sidebar = "_j3-h";
export var sidebarHeader = "_j3-j";
export var sidebarList = "_j3-i";
export var sidebarListItem = "_j3-k";
export var sidebarSearch = "_j3-l";
export var snoozeDurationWrapper = "_j3-v";
export var statusPillContainer = "_j3-m";
export var tagsContainer = "_j3-n";
export var unselectedMacro = "_j3-o";
export var variable = "_j3-u";
export var wrapper = "_j3-p";